
let OSS = require('ali-oss')
// import { getStsInfo } from 'https://api.ttdwz.cc/pc/userExcDomain/huoMaList'

export function client() {  return new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: 'LTAIy9FJTIGXy6I8',
    accessKeySecret:  'n8mw3y3Ht0re9AeggyGtFTP8TJwuPd',
    secure:true,
    bucket: 'meiguib',
    // cname:true, // 开启自定义域名上传
    // endpoint:"https://meiguib.oss-cn-beijing.aliyuncs.com/" // 自己的域名
})
}


export const getFileNameUUID = () => {
    function rx() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return `${+new Date()}_${rx()}${rx()}`
}

// export const getAliToken = (that) => {
//     //获取Token
//     return new Promise((resolve, reject) => {
//         getStsInfo().then((res) => {
//             console.log("res :>> ", res);
//             if (res.stateCode === 0) {
//                 const {
//                     AccessKeyId,
//                     AccessKeySecret,
//                     bucketName,
//                     Token,
//                     video,
//                     pic,
//                 } = res;
//                 //后台返回的存放路径
//                 that.videoOssAddress = video;
//                 that.imgOssAddress = pic;
//                 // this.expiration = expiration;
//                 that.dataObj = {
//                     region: that.region,
//                     bucket: bucketName,
//                     accessKeyId: AccessKeyId,
//                     accessKeySecret: AccessKeySecret,
//                     stsToken: Token,
//                 };
//                 resolve(res);
//             } else {
//                 reject(false);
//             }
//         })
//             .catch((err) => {
//                 console.log(err);
//             });
//     })
//
// };


// 上传视频 oss直传
// export const ossUpload = async (option, dataObj, route, callback) => {
//     const client = Client(dataObj),
//         file = option.file;
//     //随机命名
//     const random_name =
//         random_string(6) +
//         "_" +
//         new Date().getTime() +
//         "." +
//         file.name.split(".").pop();
//
//     //上传失败的话 可以放开下方注释代码 试试
//     //client.options.endpoint.protocol = "https:";
//
//     // 分片上传文件
//     await client
//         .multipartUpload(`/${route}/${random_name}`, file, {
//             progress: async function (p) {
//                 let e = {};
//                 e.percent = p * 100;
//                 option.onProgress(e);
//             },
//         })
//         .then((res) => {
//             console.log(res);
//             callback(res)
//         })
// }


// 随机生成文件名
// export const random_string = (len) => {
//     len = len || 8;
//     let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678",
//         maxPos = chars.length,
//         pwd = "";
//     for (let i = 0; i < len; i++) {
//         pwd += chars.charAt(Math.floor(Math.random() * maxPos));
//     }
//     return pwd;
// };

// export default function Client(data) {
//     //后端提供数据
//     return new OSS({
//         region: data.region,  //oss-cn-beijing
//         accessKeyId: data.accessKeyId,
//         accessKeySecret: data.accessKeySecret,
//         stsToken: data.stsToken,
//         bucket: data.bucket
//     })
// }